export const ADD_MATERIAL = "ADD_MATERIAL";
export const MERGE_MATERIALS = "MERGE_MATERIALS";
export const RESET_MATERIAL = "RESET_MATERIAL";
export const REMOVE_MATERIAL = "REMOVE_MATERIAL";
export const SELECT_MATERIAL = "SELECT_MATERIAL";
